module.exports = __webpack_public_path__ + "static/img/download_content3.735f8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_content3.png
// module id = lBwn
// module chunks = 1